/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getAllMandateTypes } from '../fn/mandate-type-controller/get-all-mandate-types';
import { GetAllMandateTypes$Params } from '../fn/mandate-type-controller/get-all-mandate-types';
import { ResponseMandateType } from '../models/response-mandate-type';

@Injectable({ providedIn: 'root' })
export class MandateTypeControllerService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getAllMandateTypes()` */
  static readonly GetAllMandateTypesPath = '/bankdetails/mandate/types';

  /**
   * Get a list of mandate types
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllMandateTypes()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMandateTypes$Response(params?: GetAllMandateTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseMandateType>> {
    return getAllMandateTypes(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a list of mandate types
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getAllMandateTypes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getAllMandateTypes(params?: GetAllMandateTypes$Params, context?: HttpContext): Observable<ResponseMandateType> {
    return this.getAllMandateTypes$Response(params, context).pipe(
      map((r: StrictHttpResponse<ResponseMandateType>): ResponseMandateType => r.body)
    );
  }

}
